import type {Vehicle} from "../vehicle/vehicle";
import type {Relation} from "@/models/relation/relation";
import type {WindowInputMode} from "@/constants/window-input-mode";

export interface AssignmentDetailModel {
    id?: number; //Used when updating
    reference?: string;
    transportReason: string;
    transportReasonId?: number;
    pickUpRelationId?: number;
    pickUpAddressId?: number;
    dropOffRelationId?: number;
    dropOffAddressId?: number;
    transportDate?: number;
    pickUpDropOffDateTime?: number[];
    pickUpWindow?: number[];
    dropOffWindow?: number[];
    pickUpWindowInputMode?: WindowInputMode | null;
    dropOffWindowInputMode?: WindowInputMode | null;
    pickUpTimeSlotPresetId?: number | null;
    dropOffTimeSlotPresetId?: number | null;
    outSourcedTo?: number;
    vehicles: Vehicle[];
    clientId?: number;
    ownerId?: number;
    pickupContactPersonName?: string;
    pickupContactPersonEmail?: string;
    pickupContactPersonPhone?: string;
    dropoffContactPersonName?: string;
    dropoffContactPersonEmail?: string;
    dropoffContactPersonPhone?: string;
}

export const DefaultAssignmentCreateModel = () => {
    return {
        transportReason: '',
        vehicles: []
    } as AssignmentDetailModel
}

//Data to show on the vehicle transport create page, but not to forward to the API
export interface AssignmentDetailData {
    pickUpRelation?: Relation;
    dropOffRelation?: Relation;
}

export const DefaultAssignmentCreateData = () => {
    return {
        pickUpRelation: undefined,
        dropOffRelation: undefined
    } as AssignmentDetailData
}
